import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useInnerBlocksProps, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes: {
      tagName: Tag
    }
  } = _ref;
  return createElement(Tag, useInnerBlocksProps.save(useBlockProps.save()));
}
//# sourceMappingURL=save.js.map